import LoadingIndicator from './LoadingIndicator';

interface Props {
  containerStyle?: object;
  description?: string;
}

export default function LoadingPage(props: Props) {
  const { containerStyle, description } = props;

  return (
    <div
      className={
        'bg-brand-background-primary h-screen w-full z-50 fixed top-0 flex flex-col justify-center items-center'
      }
      style={containerStyle}
      data-test="loading-page"
    >
      <div
        className={
          'lg:h-24 lg:w-24 md:h-20 md:w-20 h-16 w-16 rounded-xl flex justify-center items-center shadow dark:shadow-none border'
        }
      >
        <div className="-mb-2xs">
          <LoadingIndicator lg={60} md={50} sm={40} />
        </div>
      </div>
      {description && <p className="text-brand-text-secondary text-center mt-lg px-lg">{description}</p>}
    </div>
  );
}
